





























































import { Vue, Component, Ref } from 'vue-property-decorator'
import { ItemDaTabelaDePreco } from '@/models'
import { round } from '@/shareds/number-utils'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import CampoDePercentual from '@/components/ui/CampoDePercentual.vue'
import BuscaDeProdutoDropdown from '@/components/produto/BuscaDeProdutoDropdown.vue'
import BuscaDeItensSemPrecoDropdown from './BuscaDeItensSemPrecoDropdown.vue'
import DatePicker from '@/components/ui/DatePicker.vue'
import { UpdateItemUseCase } from '@/usecases'
import { FindProdutoUseCase } from '@/usecases/produto/FindProdutoUseCase'

@Component({
	components: {
		BuscaDeProdutoDropdown,
		CampoDePercentual,
		BuscaDeItensSemPrecoDropdown,
		DatePicker,
	},
})
export default class DialogoDeEdicaoDeProdutoPai extends Vue {
	@Ref() form!: HTMLFormElement

	updateItemUseCase = new UpdateItemUseCase()
	findProdutoUseCase = new FindProdutoUseCase()

	mostra = false
	carregando = false
	itemDePreco: ItemDaTabelaDePreco | null = null
	idDaTabelaDePreco: string | null = null
	precoFinalVarejo: number | null = null
	margemLucro: number | null = null
	precoCompra: number | null = null
	precoFinalVarejoOriginal: number | null = null

	async mostrar(item: ItemDaTabelaDePreco) {
		this.idDaTabelaDePreco = item.tabela.id
		this.precoFinalVarejoOriginal = item.precoFinalVarejo
		this.itemDePreco = item
		this.mostra = true
	}

	esconder() {
		this.mostra = false
		this.precoFinalVarejo = null
		this.margemLucro = null
		if (this.precoFinalVarejoOriginal && this.itemDePreco) {
			this.itemDePreco.precoFinalVarejo = this.precoFinalVarejoOriginal
		}
	}

	calculaPreco() {
		this.calculaPrecoVarejo()
		this.calculaPrecoAtacado()
	}

	calculaPrecoVarejo() {
		if (!this.itemDePreco) return
		const precoCompra = this.itemDePreco.precoCompra || 0
		const margemDeLucro = 1 + (this.itemDePreco.margemLucro || 0) / 100
		
		this.itemDePreco.precoFinalVarejo = round(
			(precoCompra * margemDeLucro ).toString(),
			2,
		)
	}

	calculaPrecoAtacado() {
		if (!this.itemDePreco) return
		this.itemDePreco.precoFinalAtacado = this.itemDePreco.precoFinalVarejo
		this.itemDePreco.descontoAtacado = this.itemDePreco.descontoVarejo
	}

	async salvarItem() {
		if(!this.itemDePreco) return
		if(!this.itemDePreco.skuProdutoPai) return
		if(!this.itemDePreco || !this.idDaTabelaDePreco) return

		this.carregando = true
		
		try {
			const itemSalvo = await this.updateItemUseCase.updateProdutoPai(
				this.idDaTabelaDePreco,
				this.itemDePreco,
				this.itemDePreco.skuProdutoPai as string,
			)
			this.$emit('salvar', itemSalvo)
			
		} catch (e) {
			AlertModule.setError(e)
		}finally{
			this.carregando = false
			this.mostra = false
			this.esconder()
			AlertModule.setSuccess('Produto pai e suas variantes foram atualizados com sucesso.')
		}
	}
}
